import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { filterConsents } from '@icc/b2b/shared';
import { ConfigService } from '@icc/shared';

export const ConsentGuard: CanActivateFn = (route, state) => {
    const configService = inject(ConfigService);
    const router: Router = inject(Router);
    if (
        (configService.config.config.Trade.consents &&
            configService.user?.user?.ActiveCompanyLicenseType === 'sublicense' &&
            filterConsents(configService.user.consents, configService.user.acceptedConsents).length) ||
        (configService.config.config.User.allowOutsideRegister &&
            configService.user?.user?.ActiveCompanyLicenseType === 'sublicense' &&
            configService.user?.consent?.img &&
            !configService.user.acceptedConsents.some((acceptedConsent) => acceptedConsent.consentId === configService.user.consent.id))
    ) {
        return router.navigate(['consent']);
    }
    return true;
};
